import React from "react";
import { Grid, Typography, Link, Container } from "@mui/material";
import { useState } from "react";
import useLogout from "../hooks/useLogout";
import useAuthentication from "../hooks/useAuthentication";
import { COLORS } from "../styles/colors";
import FullLogo from "./svg/FullLogo";
import LazylyLoadDialogContents from "./Dialogs/LazyLoadDialogContents";

/**
 * Footer for login and error pages.
 * @returns ReactElement
 */
const StickyHeader = () => {
  const { user } = useAuthentication();
  const handleLogout = useLogout();
  const [contactModalOpen, setContactModalOpen] = useState(false);

  return (
    <Container
      component="header"
      maxWidth={false}
      style={{
        height: "70px",
      }}
      sx={{ pt: 1.5, mb: 1 }}
      disableGutters
    >
      <Grid
        container
        justifyContent="space-between"
        alignContent="start"
        style={{ height: "100%" }}
        sx={{ pr: 1, pl: 2 }}
        color={COLORS.tuv_r_black_30}
      >
        <Grid item>
          <Link
            href="https://consulting.tuv.com"
            target="_blank"
            rel="noreferrer"
          >
            <FullLogo height={"50px"} />
          </Link>
        </Grid>
        <Grid item>
          <Grid container justifyContent="space-around" spacing={0.5}>
            {user && (
              <>
                <Grid item>
                  <Typography variant="body1">
                    <Link
                      style={{ color: COLORS.tuv_r_black_30 }}
                      target="_blank"
                      rel="noreferrer"
                      href="https://gis-ops.com"
                    >
                      Anleitung
                    </Link>
                  </Typography>
                </Grid>
                <Grid item style={{ userSelect: "none" }}>
                  |
                </Grid>
              </>
            )}
            <Grid item>
              {" "}
              <Typography variant="body1">
                <Link
                  component={"button"}
                  style={{ color: COLORS.tuv_r_black_30 }}
                  onClick={() => setContactModalOpen(true)}
                >
                  Kontakt
                </Link>
              </Typography>
            </Grid>
            {user && (
              <>
                <Grid item style={{ userSelect: "none" }}>
                  |
                </Grid>
                <Grid item>
                  <Typography variant="body1">
                    <Link
                      href="#"
                      style={{ color: COLORS.tuv_r_black_30 }}
                      onClick={handleLogout}
                    >
                      Logout
                    </Link>
                  </Typography>
                </Grid>
              </>
            )}
            <Grid item style={{ userSelect: "none" }}>
              |
            </Grid>
            <Grid item>
              <Typography variant="body1">
                <Link
                  onClick={() => {}}
                  component="button"
                  style={{ color: COLORS.tuv_r_black_30 }}
                >
                  DE
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <LazylyLoadDialogContents
          open={contactModalOpen}
          dialogKey="kontakt"
          onFinish={() => setContactModalOpen(false)}
        />
      </Grid>
    </Container>
  );
};

export default StickyHeader;
